import React from "react";

interface StatusBannerProps {
  type?: "info" | "warning" | "error" | "success" | "policy";
  title?: string;
  message: string;
  actionText?: string;
  onAction?: () => void;
  className?: string;
}

export function StatusBanner({
  type = "info",
  title,
  message,
  actionText,
  onAction,
  className = "",
}: StatusBannerProps): React.JSX.Element {
  return (
    <div
      className={`status-banner status-banner-${type} ${className}`}
      role={type === "error" ? "alert" : "status"}
    >
      <div className="status-banner-content">
        {title && <strong className="status-banner-title">{title}</strong>}
        <p className="status-banner-message">{message}</p>
      </div>
      {actionText && onAction && (
        <button
          type="button"
          className="btn-secondary btn-sm status-banner-action"
          onClick={onAction}
        >
          {actionText}
        </button>
      )}
    </div>
  );
}
